<template>
  <div>
    <div class="sidebar-wrapper">
      <div
        class="logo"
        :class="{ 'logo-links': this.$route.path !== '/links' }"
      >
        <LogoIcon />
      </div>
      <div
        class="breadcrumb"
        :class="{ 'breadcrumb-links': this.$route.path !== '/links' }"
      >
        <button class="back-to-links" @click="backToSmartLinks()">
          <ChevronDownIcon />
          All Links
        </button>
      </div>
      <div class="artist desktop">
        <ArtistSelectDropdown class="artist-dropdown" />
      </div>

      <div class="bottom-links">
        <div class="spacer">
          <div class="links">
            <div
              v-if="isAgency || isFamily"
              @click="creatingLink = true"
              class="link-item"
            >
              <a>
                <i class="fa-light fa-plus-circle fa-xl"></i>
                <span class="link-text">Quick Create</span>
              </a>
            </div>
            <router-link
              :to="{ name: 'SmartLinks' }"
              tag="div"
              class="link-item"
              @click.native="closeLinksMenu"
            >
              <a>
                <i class="fa-light fa-link-simple fa-xl"></i>
                <span class="link-text"
                  ><span class="link-text-desk">Smart</span> Links</span
                >
              </a>
            </router-link>
            <router-link
              :to="{ name: 'Drops' }"
              tag="div"
              class="link-item mobile-center-link"
              @click.native="closeLinksMenu"
            >
              <a>
                <i class="fa-light fa-tint fa-xl"></i>
                <span class="link-text">Drops</span>
              </a>
            </router-link>
            <router-link
              :to="{ name: 'Referrals' }"
              tag="div"
              class="link-item"
            >
              <a>
                <i class="fa-light fa-user-plus fa-xl"></i>
                <span class="link-text">Refer and Earn</span>
              </a>
            </router-link>
            <!--
      <router-link
        :to="{ name: 'Messages' }"
        tag="div"
        class="link-item"
        v-if="smsActivated"
      >
        <a>
          <RocketIcon class="link-icon" />
          <span class="link-text">Messages</span>
        </a>
      </router-link>
      -->
            <router-link :to="{ name: 'Settings' }" tag="div" class="link-item">
              <a>
                <i class="fa-light fa-gear fa-xl"></i>
                <span class="link-text">Settings</span>
              </a>
            </router-link>
            <!-- <router-link

        :to="{ name: 'Billing' }"
        tag="div"
        class="link-item"
        v-if="!hideBilling"
      >
        <a>
          <i class="fa-light fa-receipt fa-xl"></i>
          <span class="link-text">Billing </span>
        </a>
      </router-link> -->
            <router-link :to="{ name: 'Feedback' }" tag="div" class="link-item">
              <a>
                <i class="fa-light fa-lightbulb fa-xl"></i>
                <span class="link-text">Give Feedback</span>
              </a>
            </router-link>
            <div class="link-item">
              <a target="_blank" href="https://help.artisthub.io">
                <i class="fa-light fa-book fa-xl"></i>
                <span class="link-text">Help Center</span>
              </a>
            </div>
            <div class="link-item more" @click="toggleLinksMenu">
              <a>
                <i class="fa-light fa-bars fa-xl"></i>
                <span class="link-text">More</span>
              </a>
            </div>
            <!-- <LinksMenu /> -->
            <div class="links-menu" v-if="showLinksMenu">
              <div
                v-if="isAgency || isFamily"
                @click="handleClick"
                class="link-item"
              >
                <a>
                  <i class="fa-light fa-plus-circle fa-xl"></i>
                  <span class="link-text">Quick Create</span>
                </a>
              </div>
              <router-link
                :to="{ name: 'Referrals' }"
                tag="div"
                class="link-item"
                @click.native="closeLinksMenu"
              >
                <a>
                  <i class="fa-light fa-user-plus fa-xl"></i>
                  <span class="link-text">Refer and Earn</span>
                </a>
              </router-link>
              <router-link
                :to="{ name: 'Settings' }"
                tag="div"
                class="link-item"
                @click.native="closeLinksMenu"
              >
                <a>
                  <i class="fa-light fa-gear fa-xl"></i>
                  <span class="link-text">Settings</span>
                </a>
              </router-link>
              <router-link
                :to="{ name: 'Feedback' }"
                tag="div"
                class="link-item"
                @click.native="closeLinksMenu"
              >
                <a>
                  <i class="fa-light fa-lightbulb fa-xl"></i>
                  <span class="link-text">Give Feedback</span>
                </a>
              </router-link>
              <div class="link-item" @click.native="closeLinksMenu">
                <a target="_blank" href="https://help.artisthub.io">
                  <i class="fa-light fa-book fa-xl"></i>
                  <span class="link-text">Help Center</span>
                </a>
              </div>
              <div class="sign-out" @click.native="closeLinksMenu">
                <router-link
                  :to="{ name: 'Logout' }"
                  tag="div"
                  class="link-item"
                >
                  <a>
                    <i class="fa-light fa-arrow-right-to-arc fa-xl"></i>
                    <span class="link-text">Sign Out</span>
                  </a>
                </router-link>
              </div>
              <!-- <div class="links-menu-close" @click="closeLinksMenu">
                <div class="close-button"></div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <ArtistSelectDropdown class="artist-dropdown mobile" />
      <div class="sign-out">
        <router-link :to="{ name: 'Logout' }" tag="div" class="link-item">
          <a>
            <i class="fa-light fa-arrow-right-to-arc fa-xl"></i>
            <span class="link-text">Sign Out</span>
          </a>
        </router-link>
      </div>
      <QuickCreateLink v-if="creatingLink" @close="creatingLink = false" />
    </div>
    <div class="sidebar-line"></div>
  </div>
</template>
<script>
import LogoIcon from "@/components/AppLogo";
import ArtistSelectDropdown from "@/components/Custom/ArtistSelectDropdown";
import QuickCreateLink from "@/components/Custom/QuickCreateLink";
import ChevronDownIcon from "../../../public/img/icons/chevron-down.svg";
// import LinksMenu from "@/components/Custom/LinksMenu";

export default {
  name: "sidebar",
  components: {
    LogoIcon,
    ArtistSelectDropdown,
    QuickCreateLink,
    ChevronDownIcon,
    // LinksMenu
  },
  data() {
    return {
      widgetId: "",
      dashboard: localStorage.getItem("token").length,
      sidebarBackgroundColor: "black",
      sidebarBackground: "purple",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      width:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      creatingLink: false,
      showLinksMenu: false,
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      this.$store.dispatch("logout");
      this.$intercom.shutdown();
      document.location = "/login";
    },
    toggleLinksMenu() {
      this.showLinksMenu = !this.showLinksMenu;
      this.$emit("update:showLinksMenu", this.showLinksMenu);
    },
    closeLinksMenu() {
      this.showLinksMenu = false;
      this.$emit("update:showLinksMenu", this.showLinksMenu);
    },
    backToSmartLinks() {
      this.$router.push({ name: "SmartLinks" });
    },
    handleClick() {
      this.creatingLink = true;
      this.closeLinksMenu();
    },
  },
  created() {
    console.log(this.$route.path);
    window.Canny("identify", {
      appID: "63a21ceb6298661f17bde44b",
      user: {
        // Replace these values with the current user's data
        email: this.user.email,
        name: this.user.first_name,
        id: this.user.id,
        created: new Date().toISOString(),
      },
    });
  },
  computed: {
    smsActivated() {
      return this.$store.getters.getActivatedFeatures.includes("sms");
    },
    user() {
      return this.$store.getters.getUser;
    },
    artist() {
      return this.$store.getters.getArtist;
    },
    hideBilling() {
      // return ["agency"].includes(this.user.plan);
      return this.isFamily;
    },
    isFamily() {
      return this.user.plan === "family";
    },
    isAgency() {
      return this.user.plan === "agency";
    },
  },
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  display: none;
}
.sidebar-wrapper {
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  height: 100vh;
  color: $text-type-1;
  padding: 32px 7px 32px 3vw;
  @media screen and (max-width: 1024px) {
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: fit-content;
    padding: 15px 3vw;
    justify-content: space-between;
    .links {
      display:flex;
      flex-direction: row;
      margin-left: 4vw;
      margin-right: 70px;
      gap: 7px;
    }
    .sign-out {
      margin-top: 0;
      width: fit-content;
      // margin-left: auto;
    }
    .logo {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin-bottom: 0;
      margin-right: auto;
      img {
        width: 22px !important;
      }
    }
    .logo-text {
      display: none;
    }
    .link-item,
    .sign-out {
      margin-bottom: 0;
      .link-text {
        display: none;
      }
    }
    .link-icon {
      margin-right: 0;
    }
    .desktop {
      display: none;
    }
    .artist-dropdown {
      background: $bg-type-2;
      // z-index: 10;
      border: 1px solid $purple;
      border-radius: 10px;
      min-height: 30px;
      margin-bottom: 0;
      position: absolute;
      right: 50px;
      padding: 5px;
    }
    .link-item {
      position: relative;
      a {
        i {
          &::before {
            font-size: 18px;
          }
        }
      }
      &.router-link-active {
        &::before {
          content: "";
          position: absolute;
          top: -20px;
          left: 6px;
        }
      }
      .link-icon {
        width: 18px;
        min-height: 18px;
      }
    }
  }
  @media screen and (min-width: 1024px) {
    .mobile {
      display: none;
    }
    // margin-top: 0;
  }
}
.logo {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 30px;
  img {
    width: 30px !important;
  }
  .logo-text {
    cursor: default;
    margin-left: 12px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 21px;
    line-height: 25px;
    text-transform: uppercase;
    color: white;
  }
}
.sign-out {
  margin-top: auto;
  display: flex;
  align-items: center;
  width: 100%;
  &:hover {
    cursor: pointer;
    .link-icon {
      path {
        fill: white;
      }
    }
    .link-text {
      a,
      span {
        color: white;
        text-decoration: none;
      }
    }
  }
  .link-icon {
    margin-right: 27px;
    width: 24px;
    path {
      fill: $text-type-1;
    }
  }
}
.link-item {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
  a {
    text-decoration: none;
    display: flex;
    align-items: center;
    min-height: 24px;
  }

  //cursor: pointer;
  &:hover {
    .link-icon {
      path {
        fill: white;
      }
    }
    .link-text {
      color: white;
    }
  }
  &.router-link-active {
    &::before {
      content: "";
      position: fixed;
      z-index: 100;
      left: -5px;
      width: 10px;
      height: 10px;
      background: #9b27af;
      border-radius: 4px;
      box-shadow: 0px 0px 7px #e658ff;
    }
    .link-icon {
      path {
        fill: white;
      }
    }
    .link-text {
      color: white;
    }
  }
  .link-icon {
    margin-right: 27px;
    width: 24px;
    min-height: 24px;
    path {
      fill: $text-type-1;
    }
  }
  .link-text {
    display: block;
    float: right;
    cursor: pointer;
    text-decoration: none;
    color: $text-type-1;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    padding-top: 1px;
  }
}

.status-widget {
  //display: block;
  text-decoration: none;
  //margin: 10px 15px 0;
  //border-radius: 3px;
  //color: #3c4858 !important;
  white-space: nowrap;
  //padding: 8px 10px;
  //font-size: 13px;
  cursor: pointer;
  width: auto;
  /* &:hover {
    background: rgba(200, 200, 200, 0.2);
  } */
}

#noticeable-widget {
  color: white;
  font-size: 14px;
  -webkit-transition: opacity 300ms linear, -webkit-transform 300ms linear;
  transition: opacity 300ms linear, -webkit-transform 300ms linear;
  transition: transform 300ms linear, opacity 300ms linear;
  transition: transform 300ms linear, opacity 300ms linear,
    -webkit-transform 300ms linear;
  span {
    line-height: 30px;
  }
}

#counter {
  align-items: center;
  color: rgb(0, 252, 255);
  display: inline-flex;
  font-size: 12px;
  font-weight: 800;
  height: 18px;
  justify-content: center;
  margin-left: 8px;
  padding: 3px;
  pointer-events: none;
  position: relative;
  text-align: center;
  width: 18px;
}

#counter::after {
  align-items: center;
  animation: spin 2.2s infinite linear;
  background: transparent;
  bottom: 0;
  border: 2px dashed rgb(198, 186, 249);
  border-radius: 50%;
  content: "";
  display: flex;
  left: 0;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
i {
  color: $text-type-1;
  margin-right: 27px;
  width: 24px;
  text-align: center;
  @media (max-width: 600px) {
    margin-right: 0;
  }
}

.artist {
  // position: relative;
  margin-bottom: 20px;
  .artist-dropdown {
    background: $bg-type-2;
    padding: 10px;
    z-index: 100;
    border: 1px solid $purple;
    border-radius: 10px;
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .modal-container {
    padding: 0;
    width: 680px;
    z-index: 98;
    background: linear-gradient(
      241.25deg,
      rgba(41, 39, 85, 0.45) 4.4%,
      rgba(41, 39, 84, 0.85) 61.77%,
      rgba(27, 24, 66, 0.45) 119.94%
    );
    backdrop-filter: blur(23px);
    border-radius: 10px;

    .modal-close {
      cursor: pointer;
      position: absolute;
      top: 18px;
      right: 18px;
      display: flex;
      flex-direction: column;

      &:hover {
        svg {
          path {
            fill: white;
          }
        }

        .close-text {
          color: white;
        }
      }

      svg {
        width: 24px;

        path {
          fill: #8786ab;
        }
      }
    }

    .modal-content {
      display: flex;
      flex-direction: column;

      .add-link {
        padding: 30px;
        display: flex;
        flex-direction: column;

        .title {
          font-weight: 600;
          font-size: 18px;
          color: #ffffff;
        }

        .label {
          font-weight: 700;
          font-size: 14px;
          color: #ffffff;
          text-align: left;
        }

        .input-fields {
          margin-top: 30px;
          display: flex;
          flex-direction: column;

          .default-input {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }

          .domain-path {
            display: flex;
            margin-top: 15px;
            width: 100%;
            gap: 2%;
            .domain {
              width: 49%;
              .select {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: 100%;
                .label {
                  display: block;
                }
                select {
                  width: 100%;
                }
              }
            }
            .default-input {
              width: 49%;
            }
          }

          button {
            margin: 30px 0 10px;
          }
        }
      }
    }
  }

  .background-overlay {
    z-index: 97;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: unset;
    /* Purple-dark */
    background: $purple-dark;
    opacity: 0.9;
    backdrop-filter: blur(10px) !important;
  }

  .custom-select {
    border-radius: 5px 0px 0px 5px !important;
    border-right: unset !important;
  }
}
.more {
  display: none;
}

@media screen and (max-width: 1024px) {
  .more {
    display: block;
    flex-direction: row-reverse;
  }

  .bottom-links {
    position:fixed;
    bottom: 30px;
    width: 100%;
    z-index: 100;
  }
  .spacer {
    position: relative;
    display: block;
    // margin-top: 79px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 50%);
  }
  .breadcrumb-links {
    display: block;
  }
  .sidebar-wrapper {
    .artist-dropdown {
      right: 16px;
      border: none;
      background: transparent;
    }
    .logo-links {
      display: none;
    }
    .links {
      position: absolute;
      bottom: 0;
      padding: 12px 24px;
      border: 2px solid $text-type-0;
      border-radius: 40px;
      margin-top: 28px;
      gap: 40px;
      margin-bottom: 10px;
      margin-left: auto;
      margin-right: auto;
      // top: 50%;
      left: 47%;
      transform: translate(-50%, 50%);
      height: 49px;
      width: 50vw;
      min-width: 369px;
      background: $bg-type-4;
    }
    .mobile-center-link {
      a {
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
    .link-item.router-link-active::before {
      display: none;
    }
    .link-item .link-text {
      display: block;
      font-weight: 600;
      font-size: 16px;
    }
    // .links-menu {
    //   position: absolute;
    //   bottom: 64px;
    //   left: 0;
    //   width: 100%;
    //   z-index: 100;
    //   background: $purple-dark;
    //   padding: 20px 16px;
    //   border: 1px solid $text-type-0;
    //   border-radius: 10px;
    //   gap: 20px;
    //   display: flex;
    //   flex-direction: column;
    //   .link-item {
    //     display: block;
    //   }
    // }
    // .artist-dropdown {
    //   border: none;
    //   background: transparent;
    // }
  }
  // .sidebar-wrapper .artist-dropdown {
  //   right: 16px;
  // }
  // .sidebar-wrapper .logo-links {
  //   display: none;
  // }
  .back-to-links {
    cursor: pointer;
    display: flex;
    align-items: center;
    border: none;
    background: $bg-type-2;
    border-radius: 5px;
    padding: 5px 10px;
    height: 32px;
    font-weight: 600;
    line-height: 15px;
    /* Text/type0 */
    color: $text-type-0;
    color: white;
    background: linear-gradient(46.19deg, #9c27b0 5.66%, #9733ee 94.35%);
    svg {
      margin-right: 10px;
      transform: rotate(90deg);
      width: 14px;

      path {
        stroke: white;
      }
    }
  }
  .close-button {
    position: relative;
    width: 21px;
    height: 21px;
    cursor: pointer;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 36px;
  }

  .close-button::before,
  .close-button::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 2px;
    background-color: white;
  }

  .close-button::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  .close-button::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  // .sidebar-wrapper .links {
  //   position: absolute;
  //   bottom: 0;
  //   padding: 12px 24px;
  //   border: 2px solid $text-type-0;
  //   border-radius: 40px;
  //   margin-top: 28px;
  //   gap: 40px;
  //   margin: auto;
  // }

  // .links::before {
  //   position: absolute;
  //   content: "";
  //   bottom: -7px;
  //   height: 7px;
  //   width: 1px;
  //   background: radial-gradient(circle, #1b193c 0%, #0b0c14 100%);
  // }
  .links:after {
    position: absolute;
    content: "";
    bottom: -28px;
    height: 49px;
    width: 1px;
  }
  .sidebar-wrapper .link-item:nth-child(1),
  .sidebar-wrapper .link-item:nth-child(4),
  .sidebar-wrapper .link-item:nth-child(5),
  .sidebar-wrapper .link-item:nth-child(6),
  .sidebar-wrapper .link-item:nth-child(7) {
    display: none;
  }
  // .sidebar-wrapper .link-item.router-link-active::before {
  //   display: none;
  // }

  // .sidebar-wrapper .link-item .link-text {
  //   display: block;
  // }
  .link-text-desk {
    display: none;
  }
  i {
    margin-right: 10px;
  }
  .sidebar-wrapper .links-menu {
    position: absolute;
    bottom: 64px;
    left: 0;
    width: 100%;
    z-index: 100;
    background: $purple-dark;
    padding: 20px 16px;
    border: 1px solid $text-type-0;
    border-radius: 10px;
    gap: 20px;
    display: flex;
    flex-direction: column;
    .link-item {
      display: block;
    }
  }
  .links-menu-close {
    right: -18px;
    position: absolute;
    top: -18px;
    width: 36px;
    height: 36px;
    border: 1px solid white;
    border-radius: 50%;
    background: $bg-type-2;
  }

  // .sidebar-wrapper .artist-dropdown {
  //   border: none;
  //   background: transparent;
  // }

  .sidebar-line {
    height: 2px;
    width: 100vw;
    background: $bg-type-2;
  }
}
</style>
